import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit"
import { currentUserActions } from "../reducers/currentUser";

interface UrlPathProps {
    urlPath?: string;
}

export default function useTrackPageView({ urlPath }: UrlPathProps) {
    const location = useLocation();
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
    const currentUser = useSelector((state: any) => state.currentUser);
    const { talentInfo, staffInfo, superUserInfo } = currentUser;

    useEffect(() => {
        setTimeout(() => {
            if (talentInfo || staffInfo || superUserInfo) {
                dispatch(currentUserActions.recordUserAccess({urlPath: urlPath ? urlPath : location.pathname}));
            }
        }, 3000); // Fix CSRF token not yet updated
    }, [location, talentInfo, staffInfo, superUserInfo]);
}